import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@swyftx/aviary/atoms/Button';
import { Card } from '@swyftx/aviary/atoms/Card';
import { Image } from '@swyftx/aviary/atoms/Image';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { useSnackBars } from '@swyftx/aviary/complex/GlobalSnackBars/useSnackBars';

import { useAvo } from '@hooks/Avo/useAvo';

import { useNavigateRoute } from 'src/lib/navigation/hooks';

import { HodlModal } from './HodlModal';

const HodlPromoBanner: React.FC = () => {
  const { location } = useNavigateRoute();
  const avo = useAvo();
  const { addSnackBar } = useSnackBars();

  const { t } = useTranslation('pretotypes');
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <Card className='p-24'>
        <FlexLayout alignItems='center' justifyContent='start' spacing={24} className='flex-col @sm:flex-row'>
          <FlexLayout spacing={8} className='w-full'>
            <Image image='verification_banner' className='h-64 w-64' usePalette />
            <FlexLayout direction='column' spacing={8} className='w-full'>
              <Heading size='h4'>{t('hodlPromoBanner.title')}</Heading>
              <Body size='small' color='secondary'>
                <Trans t={t} i18nKey='hodlPromoBanner.description' components={[<strong key='bold' />]} />
              </Body>
            </FlexLayout>
          </FlexLayout>
          <Button
            className='w-full @sm:w-auto'
            size='lg'
            onClick={() => {
              avo.pretotypeBannerCtaClick({ screen: location.pathname, pretotypeId: 'hodl_mode' });
              setModalOpen(true);
            }}
          >
            {t('hodlPromoBanner.secondaryActionTitle')}
          </Button>
        </FlexLayout>
      </Card>

      <HodlModal
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={() => {
          addSnackBar({
            showIcon: true,
            variant: 'success',
            content: 'Request submitted',
            duration: 3000,
          });
        }}
      />
    </>
  );
};

export { HodlPromoBanner };
